<template>
    <div id="courseLib" class="app-inner">
            <div class="public-btn-div flex align-cen" v-if="!temParms">
      <div class="public-add"  @click="addLib">
        新增素材
      </div>
    </div>
      <div class="p-tit-c">
        <div class="businessList-filter">
                <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">素材名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入素材名称" v-model="search" clearable> </el-input>
          </div>
         </div>
             <div class="fl-rt flex align-cen">
          <div class="label">素材ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入素材ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
      </div>
        <div class="businessList-filter-list flex align-cen">
              <div class="fl-le flex align-cen">
          <div class="label">素材分类：</div>
                     <el-select
                        v-model="value"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in itemList"
                          :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
        </div>
      </div>
        <div class="businessList-filter-list flex align-cen">
        <div class="label">创建时间：</div>
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          @change="classSelect"
        >
        </el-date-picker>
      </div>
       <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
        搜索
        </div>
         <div class="public-btn-small-plan" @click="uploadAllClass" v-if="!temParms">
          批量调整分类
        </div>
        <div class="public-btn-small-text" @click="reset">
        重置筛选条件
        </div>
      </div>
        </div>
      </div>
        <div class="businessList-container">
        <div class="businessList-container-table">
              <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
          @select='onTableSelect'
          :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
        >
         <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left" > </el-table-column>
          <el-table-column prop="id" label="素材ID" align="center">
         </el-table-column>
          <el-table-column prop="name" label="素材名称" align="center" width="200">
         </el-table-column>
          <el-table-column prop="classifyName" label="分类" align="center" width="200">
         </el-table-column>
          <el-table-column prop="fileSize" label="大小" align="center">
             <template slot-scope="scope">
                <div>
                    {{scope.row.fileSize | kbToMb}}
                </div>
             </template>
         </el-table-column>
         <el-table-column prop="fileLen" label="长度/页数" align="center">
          <template slot-scope="scope">
                <div>
                    {{scope.row.fileLen || '-'}}
                </div>
             </template>
         </el-table-column>
           <el-table-column prop="createBy" label="创建人" align="center">
         </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" width="200">
         </el-table-column>
                  <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="250"
                    v-if="!temParms"
            >
             <template slot-scope="scope">
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openExcel(scope.row)">下载</el-button>
                 <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="switchRadio(scope.row)">移动</el-button>
                  <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="addLib(scope.row)">替换</el-button>
                   <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="deleteLib(scope.row)">删除</el-button>
            </template>
          </el-table-column>
    </el-table>
     <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
        </div>
                   <!-- 修改成员分类 -->
   <el-dialog
  title="修改分类"
  :visible.sync="centerDialogVisible1"
  width="50%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible1"
  >
      <div class="addteamUser">
        <div class="add_container">
         <div class="fai_notext_field  flex align-cen">
             <div class="fai_notext_field_label" style="line-height:40px">素材库分类</div>
             <div class="addform ">
                  <el-radio-group v-model="radio">
                    <el-radio :label="item.id" v-for="item in itemList">{{item.name}}</el-radio>
                 </el-radio-group>
             </div>
         </div>
         <div class="btm_btn_box flex align-cen">
            <div class="fai_submit_btn" @click="setClass">确定</div>
            <div class="fai_cancel_btn" @click="reback">取消</div>
         </div>
        </div>
    </div>
   </el-dialog>
    </div>
</template>
<script>
import {materialAllClassify,materialPage,deletMaterial,editMaterial,batchUpdateClassify} from "@/api/enterprise/index"  //素材库分类、素材库分页、删除素材、修改分类、批量修改分类
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    props: {
    temParms:[String, Number],//是否为组件调用 
    type:[String, Number],//1、课程文件；2、学习文件 
    },
     components:{
      paginaTion
    },
    data () {
        return {
            businessInfo:{},
            selsctarr:[],
            catchStatus:false,
            groupIds:[],
            editId:'',
            isRadio:1,
            radio:'',
            centerDialogVisible1:false,
            headers:{},
            multipleSelection:[],
            search:'',
            search1:'',
            value:'',
            itemList:[],
            value2:'',
             start_time:'',
            end_time:'',
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            list:[],
              pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
             },

        }
    },
     activated() {
        this.getList()
    },
    created() {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
         this.getLibClass()
         if(this.temParms) this.getList()
         let token = this.$locaStorage.setAge().get('token1')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
         // 父组件调用子组件方法
         editfun(val){
            this.selsctarr = val
        },
         // 新增修改调用清空方法
        remove(){
           this.multipleSelection = []
        },
        uploadAllClass(){
            if(this.multipleSelection.length == 0 ) return this.$util.Notifi('至少选择一个素材','error','fa-exclamation-circle') 
            this.centerDialogVisible1 = true
        this.isRadio = 2
        },
        // 移动、批量修改分类
        setClass(){
             if(this.radio == '' ) return this.$util.Notifi('请选择分类','error','fa-exclamation-circle') 
            let params = {}
            if(this.isRadio == 1){
                params = {
                    classifyId:this.radio,
                    id:this.editId,
                   businessId:this.businessInfo.id
                }
                    editMaterial(params,'put')
                    .then(res => {
                        if(res.code == 0){
                         this.$util.Notifi('移动成功','success','fa-check')
                         this.centerDialogVisible1 = false
                         this.getList()
                        }else{
                        this.$message.error(res.msg)
                        }
                    })
                    .catch(err => {
                    })
            }
            if(this.isRadio == 2){
                this.groupIds = this.multipleSelection.map(item => item.id)
                params = {
                ids:this.groupIds,
                classifyId:this.radio,
                businessId:this.businessInfo.id
            }
             batchUpdateClassify(params)
           .then(res =>{
             if(res.code == 0){
                 this.$util.Notifi('批量分类修改成功','success','fa-check')
                 this.centerDialogVisible1 = false
                 this.$refs.multipleTable.clearSelection();
                  this.getList()
             }else{
                this.$util.Notifi(res.msg, "error", "fa-exclamation-circle");
             }
           })
            }
        },
        reback(){
            this.centerDialogVisible1 =false
            this.radio = ''
        },
        switchRadio(data){
            // isRadio 1、替换；2、批量修改分类
            this.editId = data.id
            this.isRadio = 1
            this.centerDialogVisible1 = true
        },
        // 下载
        openExcel(data){
            alert(data.url)
            window.open(data.url,'_blank')
        },
        // 删除素材
        deleteLib(data){
                 this.$confirm('确定要删除该素材吗？删除后不可恢复，请您谨慎操作', '删除素材', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
              }).then(() => {
                  deletMaterial({id:data.id},'DELETE')
                  .then(res =>{
                    if(res.code == 0){
                      this.$util.Notifi('删除成功','success','fa-check')
                   this.getList()
                    }else{
                      this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                  })
              }).catch(() => {          
              });
        },
             // 素材列表
        getList(){
            let params = {
                name:this.search,
                id:this.search1,
                classifyId:this.value,
                createTimeStart:this.start_time,
                createTimeEnd:this.end_time,
                size:this.PageSize,
                current:this.currentPage,
                businessId:this.businessInfo.id
            }
            materialPage(params)
            .then(res => {
            this.list = res.data.records
            this.totalCount = res.data.total
              if(this.temParms){
              let rows = []
                         for (let m = 0; m < this.selsctarr.length; m++) {
                        for (let n = 0; n < this.list.length; n++) {
                        if (this.selsctarr[m].id === this.list[n].id || this.selsctarr[m].materialId === this.list[n].id) {
                            
                            rows.push(this.list[n])
                        }
                        }
                    }
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row,true)
                    })
             }
          })
          .catch(err => {})

        },
          // 获取分类
        getLibClass(){
            this.itemList = []
             materialAllClassify({
                name:'',
                businessId:this.businessInfo.id
             })
            .then(res => {
              if(res.data){
               this.itemList = res.data
              }else{
                    this.itemList = []
             }

            })
            .catch(err => {
            })
        },
        // 新增素材库
        addLib(data){
            this.$router.push({
        name: "addenMaterial",
        query:{
            id:data.id,
        }
        })
        },
        // 筛选
        classSelect(){
           if(this.value2){
             this.start_time = this.value2[0]
            this.end_time = this.value2[1]
            }else{
              this.start_time = ""
              this.end_time = ""
            }
            this.currentPage = 1
            this.getList()
        },
        //  重置
        reset(){
            this.search = ''
            this.search1 = ''
            this.value = ''
            this.value2 = []
            this.start_time = ''
            this.end_time = ''
            this.currentPage = 1
            this.getList()
        },
          emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getList()
      },
                 // 手动选择
    onTableSelect(rows, row){
         this.catchStatus = rows.length && rows.indexOf(row) !== -1
    },
              getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
         this.multipleSelection = []
              let  uniqueArray = [...new Map(val.map(item => [item.id, item])).values()];
               this.multipleSelection = uniqueArray;
                if(this.catchStatus){
             this.multipleSelection = uniqueArray;
             let arr =  this.multipleSelection
           if(this.selsctarr && this.selsctarr.length){
              let add = this.selsctarr.filter(item=>!arr.some(ele=>ele.id===item.id)) 
            for (const key in add) {
             this.multipleSelection.push({
                    'fileName': add[key].fileName,
                    'materialId':add[key].id,
                    'fileSize':add[key].fileSize,
                    'type':add[key].type,
                    'url':add[key].url,
                    'fileId':add[key].fileId,
                })

        }
          this.multipleSelection = this.multipleSelection.filter(item => item.classifyId); //去重，防止同一条数据出现两次
           }
                }else{
                   this.multipleSelection = uniqueArray; 
                }
           this.$emit('sendStatus', this.multipleSelection,false)
      },
    },
    filters: {
        kbToMb(value) {
            return (value / 1024 / 1024).toFixed(2) + ' MB'
        }
        }
}
</script>
<style lang="scss" scoped>
.addteamUser{
    padding-top: 30px;
    font-weight: 400;
    .add_container{
     position: relative;
    margin: 0 auto;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 0 7px 0 rgba(197,197,197,0.34);
    padding: 40px 105px;
    box-sizing: border-box;
    margin-bottom: 40px;
    .fai_notext_field {
    min-height: 28px;
    line-height: 28px;
    margin-bottom: 20px;
    .fai_notext_field_label{
    font-size: 18px;
    color: #90909e;
    text-align: right;
      font-weight: bold;
    }
    }
    .btm_btn_box{
        margin-top: 30px;    
        justify-content: center;
    .fai_submit_btn,.fai_cancel_btn,.fai_cancel_btn1{
        width: 270px;
            height: 40px;
    line-height: 40px;
    background: rgba(255,255,255,1);
    border-radius: 2px;
    box-sizing: content-box;
    font-size: 16px;
    cursor: pointer;
    transition: all .3s linear;
    text-align: center;
    }
    .fai_submit_btn{
        border: 1px solid rgba(1,87,255,1);
        color: #0157ff;
    }
    .fai_cancel_btn{
    border: 1px solid rgba(1,87,255,1);
    color: #0157ff;
    border: 1px solid #dadada;
    color: #90909e;
    margin-left: 30px;
    }
       .fai_cancel_btn1{
        border: 1px solid red;
    color: red;
    margin-left: 30px;
       }
    }
    }
}
#course{
         .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
    .businessList-container {
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
  
}
  ::v-deep {
          .addform{
    margin-left: 50px;
    flex-wrap: wrap;
         .el-radio{
        display: block !important;
        margin-bottom: 15px;
    }
    .addform-list{
        // width: 100%;
        .appname{
            line-height:35px;
        }
        .apptime{
            color: red;
        }
    }
      .el-tree-node__content{
          height: 40px !important;
      }
      .el-tree{
          display: flex;
          flex-wrap: wrap;
      }
  }
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
  }
</style>